import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { format, required } from 'redux-form-validators';
import { Button, Col, Row } from '@swift-paypal/pp-react';
import resolve from '../../../services/route.service';
import { normalizePhone } from '../../../lib/forms/normalizations';
import floatingLabelField from '../../../lib/forms/floating-label-field';
import routes from '../../../routes';
import withUrlParams from '../../../hocs/with-url-params';
import constants from '../../../constants';

const { errors } = constants;

const HomePhoneForm = ({
  handleSubmit,
  country,
}) => {
  const history = useHistory();

  return (
    <div className="form" data-automation-id="homePhoneForm">
      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} sm={10}>
            <Field
              name="phone"
              label="Phone number"
              manualSet
              component={floatingLabelField}
              type="text"
              className="form-control vx_form-control"
              noErrorClass="margin-bottom-sm"
              validate={[
                required({ msg: errors.requiredField }),
                format({ with: /^\(\d{3}\) \d{3}-\d{4}/, msg: errors.invalidPhone }),
              ]}
              normalize={normalizePhone}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6} sm={5} md={4}>
            <Button type="submit" className="pp-react__button--block continue-button">
              Continue
            </Button>
          </Col>
          <Col xs={6} sm={5} md={4}>
            <Button
              secondary
              type="button"
              className="pp-react__button--block"
              onClick={() => history.push(resolve(routes.settings.path, { country }))}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </form>
    </div>
  );
};

HomePhoneForm.propTypes = {
  country: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func,
};

HomePhoneForm.defaultProps = {
  handleSubmit: undefined,
};

const HomePhoneFormComponent = reduxForm({
  form: 'add-home-phone',
})(HomePhoneForm);

export default compose(
  connect(),
  withRouter,
  withUrlParams,
)(HomePhoneFormComponent);
